import React, { FC, useCallback } from 'react';
import { Field, useFormikContext } from 'formik';
import styled from 'styled-components';
import { Label } from '@inplayer-org/inplayer-ui';

// styled components
import { BlueTypography } from 'components/SharedStyledElements';

// components
import Input from 'components/Fields/Input';
import FieldError from 'components/Fields/FieldError';

// hooks
import useWillMount from 'hooks/useWillMount';
import { useUncontrolledSwitch } from 'components/Switcher';

// own components
import Moderation from './Moderation';
import BackButton from '../../components/BackButton';

// own various
import { TwoRowGrid } from '../Field';
import { FormValues, TOP_FIELD_NAME } from '../../LiveLikeChatForm';

const HeadingTypography = styled(BlueTypography)`
  margin-bottom: 2em;
`;

const InputContainer = styled.div`
  margin: 0.5em 0;
`;

interface Props {
  heading?: string;
  isTitleReadOnly?: boolean;
  modifiedValues?: Partial<FormValues>;
}

const ChatroomEdit: FC<Props> = ({ heading, isTitleReadOnly = false, modifiedValues }) => {
  const { values, setValues, resetForm, dirty, initialValues } = useFormikContext<FormValues>();

  const { resetToDefault: goBack } = useUncontrolledSwitch();

  useWillMount(() => {
    if (dirty) {
      if (!initialValues.chatroom.id) {
        return;
      }

      setValues({ ...values, ...modifiedValues });

      return;
    }

    resetForm({
      values: { ...values, ...modifiedValues },
    });
  });

  const handleGoBack = useCallback(() => {
    resetForm();
    setValues(values);
    goBack();
  }, []);

  return (
    <TwoRowGrid>
      <BackButton onClick={handleGoBack}>Back</BackButton>
      <div>
        {heading && <HeadingTypography variant="h6">{heading}</HeadingTypography>}
        <Label>Chat title</Label>
        <InputContainer>
          <Field
            tag="text_chat_room"
            name={`${TOP_FIELD_NAME}.title`}
            type="text"
            component={Input}
            placeholder="Chat title"
            disabled={isTitleReadOnly}
          />
          <FieldError name={`${TOP_FIELD_NAME}.title`} />
        </InputContainer>
        <Moderation />
      </div>
    </TwoRowGrid>
  );
};

export default ChatroomEdit;
